import Modal from "react-bootstrap/Modal";
import logoPNG from "../assets/img/logo.png";
import IconWhitCheck from "../assets/svg/white_check.svg";
import IconError from "../assets/svg/error.svg";
function ModalAlertLoading(props) {
  const { messageModal, show, setShow, iconToShow } = props;
  
  const handleClose = () => setShow(false);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        contentClassName="rounded-4 overflow-hidden border border-0 greenArbitragem style-modal-loading"
        backdropClassName="style-backdrop-modal-loading"
      >
        <Modal.Body className="text-light">
          <div className="d-flex flex-column align-items-center text-center py-3 px-5">
            <img
              src={logoPNG}
              alt="Apito"
              className=" style-size-image-logo-loading-page-modal"
            />
            {iconToShow === "success" ? (
              <div className="mt-4">
                <img
                  src={IconWhitCheck}
                  alt="White Icon Check"
                  style={{ width: "40px", height: "auto" }}
                />
              </div>
            ) : iconToShow === "error" ? (
              <div className="mt-4">
                <img
                  src={IconError}
                  alt="White Icon Check"
                  style={{ width: "40px", height: "auto" }}
                />
              </div>
            ) : (
              <div className="spinner-border text-light mt-4" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
            <div className="text-light fs-4 fw-bold">{messageModal}</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalAlertLoading;
